import { isArray } from 'lodash'
import { isSupportedLanguage, isSupportedRoles, recursiveIncludes, validateString } from '..'
import { getTimezoneLessMoment } from '../momentjs'
import { EUROPEAN_DATE, ROLE_HOSPITAL_ADMIN, ROLE_NURSE } from '../constants'
import { VALIDATION_FIELDS } from '../validators'

export const USER_VALIDATORS = [
  { key: VALIDATION_FIELDS.EMAIL, validator: u => validateString(u.email, { notEmpty: true, isEmail: true }) },
  { key: VALIDATION_FIELDS.USERNAME, validator: u => validateString(u.username, { notEmpty: true, isEmail: true }) },
  { key: VALIDATION_FIELDS.LASTNAME, validator: u => validateString(u.lastname, { notEmpty: true }) },
  { key: VALIDATION_FIELDS.FIRSTNAME, validator: u => validateString(u.firstname, { notEmpty: true }) },
  { key: VALIDATION_FIELDS.LANGUAGE, validator: u => isSupportedLanguage(u.language) },
  { key: VALIDATION_FIELDS.ROLES, validator: u => isSupportedRoles(u.roles ? u.roles[0] : null) },
  { key: VALIDATION_FIELDS.INSTITUTIONS, validator: u => !isSupportedRoles(u.roles ? u.roles[0] : null).valid || !recursiveIncludes([ROLE_HOSPITAL_ADMIN, ROLE_NURSE], u.roles) || u.institutions.length > 0 }
]

export const getEmail = user => {
  return user.email
}

export const getFirstname = user => {
  return user.firstname
}

export const getInstitutionsName = user => {
  let name = '/'

  if (isArray(user.institutions)) {
    name = user.institutions.map(i => i.name).join(', ')
  }

  return name
}

export const getLanguage = user => {
  return user.language
}

export const getLastConnection = user => {
  return user.lastLogin ? getTimezoneLessMoment(user.lastLogin).format(EUROPEAN_DATE) : ''
}

export const getLastname = user => {
  return user.lastname
}

export const getRole = user => {
  return isArray(user.roles) ? user.roles[0] : null
}

export const getUsername = user => {
  return user.username
}

export const getLanguageWithoutLocale = user => user.language.split('_')[0]

export class User {
  constructor ({ id, email, firstname, institutionGroup, institutions, language, lastname, roles, username } = {}) {
    this.id = id ?? -1
    this.email = email ?? ''
    this.firstname = firstname ?? ''
    this.institutionGroup = institutionGroup ?? null
    this.institutions = institutions ?? []
    this.language = language ?? ''
    this.lastname = lastname ?? ''
    this.roles = roles ?? []
    this.username = username ?? ''
  }

  toRequestBody = () => {
    return {
      id: this.id,
      email: this.email,
      firstname: this.firstname,
      language: this.language,
      lastname: this.lastname,
      roles: this.roles,
      username: this.username,
      institutionGroup: this.institutionGroup?.id ?? null,
      institution: this.institutions.length > 0 ? this.institutions[0].id : null
    }
  }
}
